import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { PaymentSetupIcon } from "../../../../assets/icons/MUI/PaymentIcons";
import { SetupPaymentAccountProps } from "../../payment.types";

const SetupPaymentAccount = ({
  openLearnMorePopUp,
  handleSetupPaymentAccount,
  handleAddReceivingDetails,
}: SetupPaymentAccountProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Typography
        component="p"
        sx={{
          color: "#111",
          fontFamily: "Montserrat",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "20px",
          marginBottom: "16px",
        }}
      >
        {/* {t("pages.payment.overview.simplifyYourPayments")} */}
        {t("pages.payment.overview.v2.howToReceiveMoneySubtitle")}
      </Typography>
      <Box
        component="ul"
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: "12px",
          margin: "0 0 24px",
        }}
      >
        {[
          // t("pages.payment.overview.setUpStripe"),
          // t("pages.payment.overview.bankAccountDetails"),
          // t("pages.payment.overview.paymentSettings"),
          t("pages.payment.overview.v2.addReceivingDetailsTitle"),
          t("pages.payment.overview.v2.goalngoCollectsPayments"),
          t("pages.payment.overview.v2.getYourEarnings"),
        ].map((text: string) => (
          <Typography
            component="li"
            sx={{
              display: "flex",
              columnGap: "12px",
              color: "#475467",
              fontFamily: "Montserrat",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "28px",
            }}
          >
            <PaymentSetupIcon />
            {text}
          </Typography>
        ))}
      </Box>
      <Box sx={{ display: "flex", columnGap: "16px" }}>
        {/* <Button variant="primary-md" onClick={handleSetupPaymentAccount}>
          {t("pages.payment.overview.setupPaymentAccount")}
        </Button>
        <Button variant="outlined-md" onClick={openLearnMorePopUp}>
          {t("pages.payment.overview.learnMore")}
        </Button> */}
        <Button variant="primary-md" onClick={handleAddReceivingDetails}>
          {t("pages.payment.overview.v2.addReceivingDetailsButton")}
        </Button>
        <Button variant="outlined-md" onClick={openLearnMorePopUp}>
          {t("pages.payment.overview.v2.learnMoreButton")}
        </Button>
      </Box>
    </Box>
  );
};

export default SetupPaymentAccount;
